module.exports = __webpack_public_path__ + "static/img/banner1.86040948.png";